import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-22ee52d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ids" }
const _hoisted_2 = { class: "ids__elm" }
const _hoisted_3 = { class: "ids__elm-settings" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-label" }, "Настройки", -1))
const _hoisted_5 = { class: "ids__elm-settings-item" }
const _hoisted_6 = { class: "ids__elm-settings-item-key" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-item-val" }, " Отмечать входящие сообщения прочитанными ", -1))
const _hoisted_8 = { class: "ids__elm-settings-item" }
const _hoisted_9 = { class: "ids__elm-settings-item-key" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-item-val" }, " Отмечать входящие сообщения прочитаннымы при отправке через API ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-line" }, null, -1))
const _hoisted_12 = { class: "ids__elm-settings-interval" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-interval-key" }, " Интервал отправки сообщений из очереди ", -1))
const _hoisted_14 = { class: "ids__elm-settings-interval-val" }
const _hoisted_15 = { class: "ids__elm-settings-interval-val-msec" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-label_notify" }, "Уведомления", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-url-label" }, " Адрес отправки уведомлений (URL) ", -1))
const _hoisted_18 = { class: "ids__elm-settings-url" }
const _hoisted_19 = {
  key: 0,
  class: "ids__elm-settings-url-wrap-link"
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "ids__elm-settings-url-copy" }
const _hoisted_22 = { class: "ids__elm-settings-item" }
const _hoisted_23 = { class: "ids__elm-settings-item-key" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-item-val" }, " Получать уведомления о входящих сообщениях и файлах ", -1))
const _hoisted_25 = { class: "ids__elm-settings-item" }
const _hoisted_26 = { class: "ids__elm-settings-item-key" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-item-val" }, " Получать уведомления о статусах отправленных сообщениях ", -1))
const _hoisted_28 = { class: "ids__elm-settings-item" }
const _hoisted_29 = { class: "ids__elm-settings-item-key" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-item-val" }, " Получать уведомления о сообщениях, отправленных с телефона ", -1))
const _hoisted_31 = { class: "ids__elm-settings-item" }
const _hoisted_32 = { class: "ids__elm-settings-item-key" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-item-val" }, " Получать уведомления о сообщениях, отправленных с API ", -1))
const _hoisted_34 = { class: "ids__elm-settings-item" }
const _hoisted_35 = { class: "ids__elm-settings-item-key" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-item-val" }, " Получать уведомления об изменении состояния авторизации аккаунта ", -1))
const _hoisted_37 = { class: "ids__elm-settings-item" }
const _hoisted_38 = { class: "ids__elm-settings-item-key" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ids__elm-settings-item-val" }, " Выставлять статус - (В сети) ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiSwitcher = _resolveComponent("UiSwitcher")!
  const _component_IconCopy = _resolveComponent("IconCopy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_UiSwitcher, {
              "is-array-items": true,
              name: "markIncomingMessagesReaded",
              "is-checked": _ctx.isMarkIncomingMessagesRead,
              onCheckedItem: _ctx.handleChecked
            }, null, 8, ["is-checked", "onCheckedItem"])
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_UiSwitcher, {
              "is-array-items": true,
              name: "markIncomingMessagesReadedOnReply",
              "is-checked": _ctx.isMarkIncomingMessagesReadOnReply,
              onCheckedItem: _ctx.handleChecked
            }, null, 8, ["is-checked", "onCheckedItem"])
          ]),
          _hoisted_10
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.DELAY_SEND_MESSAGE) + " мс ", 1)
          ])
        ]),
        _hoisted_16,
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
            class: "ids__elm-settings-url-wrap"
          }, [
            (!_ctx.isFocus)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.webhookUrl), 1))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              ref: "inputUrl",
              onFocusout: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
              tabindex: "0",
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inputUrl && _ctx.inputUrl(...args))),
              value: _ctx.webhookUrl,
              type: "text",
              class: "ids__elm-settings-url-wrap-input",
              placeholder: "URL"
            }, null, 40, _hoisted_20), [
              [_vShow, _ctx.isFocus]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_IconCopy, {
              class: "ids__elm-settings-url-copy-icon",
              onClick: _ctx.onClipboard
            }, null, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_UiSwitcher, {
              "is-array-items": true,
              name: "incomingWebhook",
              "is-checked": _ctx.isIncomingWebhook,
              onCheckedItem: _ctx.handleChecked
            }, null, 8, ["is-checked", "onCheckedItem"])
          ]),
          _hoisted_24
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_UiSwitcher, {
              "is-array-items": true,
              name: "outgoingWebhook",
              "is-checked": _ctx.isOutgoingWebhook,
              onCheckedItem: _ctx.handleChecked
            }, null, 8, ["is-checked", "onCheckedItem"])
          ]),
          _hoisted_27
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_UiSwitcher, {
              "is-array-items": true,
              name: "outgoingMessageWebhook",
              "is-checked": _ctx.isOutgoingMessageWebhook,
              onCheckedItem: _ctx.handleChecked
            }, null, 8, ["is-checked", "onCheckedItem"])
          ]),
          _hoisted_30
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_UiSwitcher, {
              "is-array-items": true,
              name: "outgoingAPIMessageWebhook",
              "is-checked": _ctx.isOutgoingAPIMessageWebhook,
              onCheckedItem: _ctx.handleChecked
            }, null, 8, ["is-checked", "onCheckedItem"])
          ]),
          _hoisted_33
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_UiSwitcher, {
              "is-array-items": true,
              name: "stateWebhook",
              "is-checked": _ctx.isStateWebhook,
              onCheckedItem: _ctx.handleChecked
            }, null, 8, ["is-checked", "onCheckedItem"])
          ]),
          _hoisted_36
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_UiSwitcher, {
              "is-array-items": true,
              name: "keepOnlineStatus",
              "is-checked": _ctx.isKeepOnlineStatus,
              onCheckedItem: _ctx.handleChecked
            }, null, 8, ["is-checked", "onCheckedItem"])
          ]),
          _hoisted_39
        ])
      ])
    ])
  ]))
}